import { useMemo } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { findGroupByKey } from '@/domain/store-group'
import { useStoreGroups } from './use-store-groups'

// The stores the navbar narrows pages to: the selected store, or every store of the selected
// group. Undefined means no narrowing: the backend scopes by the caller's own group claim.
export function useSelectedEcommerceIds(): string[] | undefined {
  const selectedEcommerce = useAppSelector(
    (s) => s.generalData.selectedEcommerce
  )
  const selectedGroup = useAppSelector((s) => s.generalData.selectedGroup)
  const groups = useStoreGroups()

  return useMemo(() => {
    if (selectedEcommerce) return [selectedEcommerce]
    return findGroupByKey(groups, selectedGroup)?.ecommerces
  }, [selectedEcommerce, selectedGroup, groups])
}

// The comma-separated form the processes and line-items filters take for several stores.
export function useEcommerceFilter() {
  return useSelectedEcommerceIds()?.join(',')
}
